import { iconCloseSmall, iconStatusErrorSmall, iconStatusInfoSmall, iconStatusSuccessSmall, iconStatusWarningSmall, } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon, IconButton, Text } from '../index.js';
const statusIconMap = {
    info: iconStatusInfoSmall,
    success: iconStatusSuccessSmall,
    error: iconStatusErrorSmall,
    warning: iconStatusWarningSmall,
};
// A map of each conditional prop to an array of props that would be invalid if combined.
// For example, filter can't be combined with status, statusColor, pastel, or customIcon props.
const invalidPropComboMap = {
    status: ['onClose', 'statusColor', 'statusColorBright', 'icon'],
    statusColor: ['status', 'onClose'],
    statusColorBright: ['status', 'onClose'],
    icon: ['onClose', 'status'],
};
// Check if the chip prop combinations are used correctly.
const validateChipProps = (props) => {
    let valid = true;
    // Loop through the invalid prop combo map keys e.g. (filter, status, statusColor...).
    for (const [key] of Object.entries(invalidPropComboMap)) {
        const propKey = key;
        // If no value is found for the prop, continue to next prop
        if (!props[propKey])
            continue;
        // Get the keys for the other props that should not be used with the current prop we are checking.
        const invalidPropKeys = invalidPropComboMap[propKey];
        // Loop through the invalidPropKeys and if any of them have a value warn to the console.
        for (const invalidPropKey of invalidPropKeys) {
            if (props[invalidPropKey]) {
                console.warn(`This chip component has invalid props. The props '${key}' and '${invalidPropKey}' should not be used together. See https://design.tesla.com/docs/components/chip for valid examples.`);
                valid = false;
                break;
            }
        }
        // Break out of the loop, provide the user with only one console warning at a time.
        if (!valid) {
            break;
        }
    }
};
export const Chip = (props) => {
    const { onClose, className, closeProps, text, icon, status, statusColor, statusColorBright, unencapsulated, caption, weight, contrast, fullWidth, density, ...rest } = props;
    validateChipProps(props);
    return (React.createElement("span", { className: cx('tds-chip', {
            [`tds-density--${density}`]: density,
            ['tds-chip--unencapsulated']: unencapsulated,
            ['tds-chip--full-width']: fullWidth,
            [`tds-chip--${statusColor}`]: statusColor && statusColorBright,
            [`tds-chip--${statusColor}-pastel`]: statusColor && !statusColorBright,
        }, className), ...rest },
        status && React.createElement(Icon, { data: statusIconMap[status] }),
        icon,
        statusColor && unencapsulated && (React.createElement("span", { className: "tds-chip-circle-container" },
            React.createElement("span", { className: "tds-chip-circle" }))),
        text && (React.createElement(Text, { className: "tds-chip-text", weight: weight, contrast: contrast }, text)),
        caption && React.createElement(Text, { className: "tds-chip-caption" }, caption),
        onClose && (React.createElement(IconButton, { onClick: onClose, size: "small", ...closeProps },
            React.createElement(Icon, { data: iconCloseSmall })))));
};
